import { Box, Stack, Typography, IconButton, Dialog } from "@mui/material";
import { DeleteForever, Edit } from "@mui/icons-material";
import React, { useState } from "react";
import { useEffect } from "react";
import BilletEditForm from "../forms/billetEdit";

export default function BilletInfoSection({ billet, rmBillet, setLoad, setPanier }) {
    const [event , setEvent] = React.useState(null);
    const [open, setOpen] = useState(false);
    const [action, setAction] = useState('');

    function manageDialog(open, action = '') {
        setOpen(open);
        setAction(action);
    }

    async function handleDelete(){
        setLoad(true);
        fetch(process.env.REACT_APP_API_URL.concat('/billets/'+ billet._id), {method: 'DELETE', headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('anonUserId') || ''}`
        }})
        .then(response => {
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (!response.ok) {
                throw new Error('Failed to fetch event');
            }
            rmBillet()
            setLoad(false);
        })
        .catch(error => console.error('Error fetching project:', error));
    }

    useEffect(() => {
        if (billet.event) {
            fetch(`${process.env.REACT_APP_API_URL}/public/event/${billet.event}`)
                .then(response => {
                    const token = response.headers.get('x-auth-token');
                    if (token) localStorage.setItem('token', token);
                    return response.json()
                })
                .then(data => {
                    setEvent(data);
                    if(data.statut !== 'en cours') {
                        handleDelete();
                        alert('Votre panier contenait des billets pour des évènements qui ne sont plus en cours d\'inscription. Ils ont donc été supprimés.');
                    }
                    //supression des billets dont le tarif n'est plus dispo
                    else if (data.tarifs.some(t => t.type!=='normal' && t.nom === billet.tarif && t.montant === billet.price && t.tickets_restants === 0)) {
                        handleDelete();
                        alert('Votre panier contenait des billets pour des tarifs qui ne sont plus disponibles. Ils ont donc été supprimés.');
                    }
                })
                .catch(error => console.error('Error fetching event:', error));
        }
    }, [billet.event]);

    return <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, py: 2, px:{xs: 1, sm: 2}}}>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent={'space-between'}>
            <Stack direction="row" spacing={{xs: 1, sm: 2}} alignItems="center">
                <IconButton onClick={handleDelete} sx={{color:'alerte.main'}}>
                    <DeleteForever />
                </IconButton>
                <Box>
                    <Typography variant="h6" textTransform='capitalize'>{event?.titre} - {billet.tarif}</Typography>
                    <Stack direction="row" spacing={1} alignItems='center'>
                        <Typography variant="body1" fontSize={14}>billet au nom de <span style={{textTransform:'capitalize'}}>{billet.owner?.nom+' '+billet.owner?.prenom}</span></Typography>
                        <IconButton onClick={() => manageDialog(true, 'edit')}><Edit sx={{fontSize: 14}}/></IconButton>
                    </Stack>
                </Box>
            </Stack>
            <Typography variant="body1" sx={{whiteSpace: 'nowrap'}}>{billet.price?.toFixed(2)} €</Typography>
        </Stack>

        <Dialog {...{open, onClose: () => manageDialog(false), maxWidth: 'md', fullWidth: true}}>
            {action === 'edit' && <BilletEditForm {...{event, billet, close:() => manageDialog(false), 
                updateBillet:(bl)=> setPanier(old=> ({...old, items: old.items.map(i => i.id._id === bl._id ? {...i, id: bl} : i)}))}} />}
        </Dialog>
    </Box>
}